export const productsKeys = {
	all: ['crm', 'products'],
	list: (filters) => ['crm', 'products', 'list', filters],
	deals: (productId) => ['crm', 'products', productId, 'deals'],
};

export const bundlesKeys = {
	all: ['crm', 'bundles'],
	list: (filters) => ['crm', 'bundles', 'list', filters],
	deals: (bundleId) => ['crm', 'bundles', bundleId, 'deals'],
};

export const productsMutationKeys = {
	create: ['crm', 'products', 'create'],
	update: ['crm', 'products', 'update'],
	delete: ['crm', 'products', 'delete'],
};

export const bundlesMutationKeys = {
	create: ['crm', 'bundles', 'create'],
	update: ['crm', 'bundles', 'update'],
	delete: ['crm', 'bundles', 'delete'],
};
